"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79698],{

/***/ 40892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dj": function() { return /* reexport */ Icons_ChevronRightSvg; },
  "V3": function() { return /* reexport */ Icons_DropDownSvg; },
  "iD": function() { return /* reexport */ Icons_LightningBoxSvg; },
  "SY": function() { return /* reexport */ Icons_LightningFilledSvg; },
  "Sf": function() { return /* reexport */ Icons_LightningSvg; },
  "bC": function() { return /* reexport */ Icons_TimerClockSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningSvg.tsx

var LightningSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1561_100863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z",
                    stroke: fill,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1561_100863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningSvg = (LightningSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningFilledSvg.tsx

var LightningFilledSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_118194)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 1L5 3.5L7 4.25L3.5 8L4 5.5L2 4.75L5.5 1Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_118194",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningFilledSvg = (LightningFilledSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningBoxSvg.tsx

var LightningBoxSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                stroke: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4016_142863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.75 3.625L10.125 6.75L12.625 7.6875L8.25 12.375L8.875 9.25L6.375 8.3125L10.75 3.625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4016_142863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white",
                        transform: "translate(4.5 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningBoxSvg = (LightningBoxSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/ChevronRightSvg.tsx

var ChevronRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_110905)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.51562 8.70331L7.21933 4.9996L3.51562 1.2959",
                    stroke: "#969696",
                    strokeOpacity: "0.6",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_110905",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ChevronRightSvg = (ChevronRightSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/DropDownSvg.tsx

var DropDownSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#00AB6B" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 6L8.5 10L12.5 6",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_DropDownSvg = (DropDownSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/TimerClockSvg.tsx

var TimerClockSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "6.00156",
                cy: "6.7252",
                r: "3.775",
                stroke: "#8277F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 4.5874V6.9624L7.1875 7.9124",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.60934",
                y1: "2.90025",
                x2: "3.457",
                y2: "1.42212",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "2.86616",
                y2: "-0.5",
                transform: "matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)",
                stroke: "#8277F8",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_TimerClockSvg = (TimerClockSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/index.ts









/***/ }),

/***/ 38639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ ContainerTemplateWrapper; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l2": function() { return /* binding */ UserRdnInfoContainer; }
/* harmony export */ });
/* unused harmony exports PageContainer, CarouselContainer, RightSection, VirtualButtonContainer, Carousel, CarouselItemContainer, CarouselImage, VirtualButton, LoginButton, RegisterButton, Input, InputPINForm, InputPINContainer, RegisterContainer, BannerRegisterContainer, BackButton, InfoRegisterContainer, Iconmoon, GrayBackButton, ProfileLabel, ProfileInputGroup, InputTokenContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61980);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(579);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: hidden;\n  position: relative;\n  margin-top: 60px;\n  height: calc(100vh - 60px);\n\n  @media ",
        " {\n    margin-top: 103px;\n    height: calc(100vh - 103px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: #5dcbad26;\n    padding: 30px;\n    height: calc(100vh - 60px);\n    max-height: 100%;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  padding: 30px;\n  overflow-y: auto;\n\n  @media ",
        " {\n    /* height: 95vh;\n    max-height: 100%; */\n    height: calc(100vh - 101px);\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: 50px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 50px;\n  height: 100%;\n  max-height: 550px;\n  margin-top: 23%;\n\n  .slick-dots {\n    width: auto;\n    bottom: -60px;\n\n    li {\n      width: unset;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active button {\n      width: 25px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 240px;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto 25px;\n  width: 180px;\n  height: 180px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px auto;\n  padding: 10px 15px;\n  border-radius: 10px;\n  background: transparent;\n\n  img {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n  padding: 6px;\n  border: 1px solid ",
        ";\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &\n    .ant-form-item-has-error\n    .ant-input-affix-wrapper-focused.securities-input-pin,\n  & .ant-form-item-has-error .ant-input-affix-wrapper,\n  & .ant-form-item-has-error .securities-input-pin:hover {\n    border-color: ",
        " !important;\n    box-shadow: none;\n  }\n\n  & .ant-form-item-explain.ant-form-item-explain-error {\n    margin-top: 4px;\n    min-height: 19px;\n\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 12px;\n      line-height: 1.5;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .eye {\n    position: absolute;\n    right: 10px;\n    width: 16px;\n    cursor: pointer;\n  }\n\n  .withdrawal-input-pin {\n    padding: 0;\n\n    &.ant-input-affix-wrapper {\n      padding: 0;\n      margin-bottom: 4px;\n    }\n\n    .ant-input-prefix {\n      background: ",
        ";\n      margin-right: 12px;\n      padding: 11px;\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n\n  .securities-input-pin {\n    margin: 15px 0 5px;\n    height: 35px;\n    padding-left: 45px;\n\n    &::placeholder {\n      font-family: var(--bold-font);\n      color: #e4e4e4;\n    }\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: ",
        ";\n      box-shadow: none;\n    }\n  }\n\n  .ant-input-group .ant-input {\n    width: 85%;\n  }\n\n  .icon-password.input-prefix {\n    position: absolute;\n    top: 15px;\n    left: 0;\n    width: 35px;\n    height: 35px;\n    text-align: center;\n    line-height: 35px;\n    border-right: 1px solid ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  height: 585px;\n  max-width: 798px;\n  margin: 20px auto;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: relative;\n  width: 40%;\n  padding: 20px;\n\n  img {\n    position: absolute;\n    right: 0;\n    top: 170px;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  height: 35px;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 40px;\n  border-left: 1px solid ",
        ";\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:before {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 20px;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin: 0 auto;\n  height: fit-content;\n  border-radius: 4px;\n  width: ",
        ";\n\n  &.deposit-section-instruction {\n    border: none;\n    border-radius: 0;\n    min-height: 100%;\n\n    i.icon-up-arrow {\n      transform: rotate(-90deg);\n      font-size: 14px;\n      color: ",
        ";\n    }\n  }\n\n  .header {\n    height: 56px;\n    padding: 0 20px;\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    .back-btn {\n      background: none;\n      border: none;\n      min-width: 30px;\n      width: fit-content;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 0;\n    }\n\n    .title {\n      font-family: var(--bold-font);\n      font-size: 18px;\n      line-height: 24px;\n      text-align: center;\n      color: ",
        ";\n    }\n\n    .right-header {\n      text-align: right;\n\n      .history-link {\n        font-size: 18px;\n        line-height: 24px;\n        text-align: right;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: nowrap;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: ",
        ";\n  text-align: left;\n\n  img {\n    display: block;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n  }\n\n  .text-content {\n    flex-grow: 1;\n    font-size: 14px;\n    line-height: 19px;\n    padding: 0 16px;\n    overflow: hidden;\n\n    p {\n      margin-bottom: 0;\n      line-height: 21px;\n    }\n\n    .rdn-name {\n      color: ",
        ";\n      word-break: break-word;\n      margin-bottom: 4px;\n    }\n\n    .rdn-account {\n      font-family: var(--bold-font);\n      color: ",
        ";\n      font-size: 13.5px;\n    }\n  }\n\n  .btn-copy {\n    background-color: #ebf6ef;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    color: ",
        ";\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: none;\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  width: 30%;\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  margin: 25px 0;\n  width: 100%;\n\n  &.small-margin {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .input-token {\n    border: 1px solid ",
        ";\n    height: 36px;\n    input {\n      border: none;\n      font-size: 16px;\n      padding: 5px;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}









var Flex = _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
var PageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var RightSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var VirtualButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-3"
})(_templateObject3(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Carousel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var CarouselItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-5"
})(_templateObject5());
var CarouselImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-6"
})(_templateObject6());
var VirtualButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-7"
})(_templateObject7());
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-8"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var RegisterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-10"
})(_templateObject10());
var InputPINForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var InputPINContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var RegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var BannerRegisterContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-14"
})(_templateObject14(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var BackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-15"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var InfoRegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-16"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);
var Iconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-17"
})(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var GrayBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-18"
})(_templateObject18(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ContainerTemplateWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-19"
})(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var width = param.width;
    if (typeof width === "number") return "".concat(width, "px");
    return width;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var UserRdnInfoContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-20"
})(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray, function(param) {
    var padding = param.padding;
    if (padding) {
        if (typeof padding === "number") return "".concat(padding, "px");
        return padding;
    }
    return "16px 24px";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-182c06c0-21"
})(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-22"
})(_templateObject22());
var InputTokenContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-23"
})(_templateObject23(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);


/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ formatShiftedCurrency; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "VZ": function() { return /* binding */ getMostMinMaxAmountRules; },
/* harmony export */   "_j": function() { return /* binding */ adjustCursorPosition; },
/* harmony export */   "_y": function() { return /* binding */ generateTimeDiffText; },
/* harmony export */   "bF": function() { return /* binding */ updateCursorPosition; },
/* harmony export */   "i$": function() { return /* binding */ isOverDailyLimit; },
/* harmony export */   "iM": function() { return /* binding */ formatPricePercentage; },
/* harmony export */   "kI": function() { return /* binding */ isUnderDailyLimit; },
/* harmony export */   "qF": function() { return /* binding */ formatBondDate; },
/* harmony export */   "uJ": function() { return /* binding */ formatBondCurrency; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);



// eslint-disable-next-line import/prefer-default-export
var formatBondDate = function(date) {
    if (!date) {
        return "-";
    }
    var formatFullMonthId = Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
    return formatFullMonthId.format(new Date(date));
};
var formatBondCurrency = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "IDR";
    return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(value).replace(/\s+/g, "");
};
var formatPricePercentage = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never";
    if (typeof value !== "number") {
        return "-";
    }
    var rawValue = value / 100;
    return Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(rawValue);
};
var formatCurrency = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rp";
    return "".concat(currency).concat(Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    }));
};
var formatShiftedCurrency = function(value) {
    var fixZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, fractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rp";
    var isNegative = value <= 0;
    var absoluteValue = Math.abs(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
    var formattedValue = "".concat(currency).concat(absoluteValue);
    if (fixZero && value === 0) return "".concat(formattedValue);
    return "".concat(isNegative ? "- " : "").concat(formattedValue);
};
var formatPrice = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
};
var formatNumber = function(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_1___default()(number).format("0,0");
};
var isOverDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && remaining < amount.min && (inputValue > remaining || inputValue > dailyMax);
};
var isUnderDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && inputValue <= dailyMax && remaining >= amount.min && inputValue > remaining;
};
var getMostMinMaxAmountRules = function(methods) {
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        var _Math, _Math1;
        var amounts = methods.map(function(method) {
            return method.amount;
        });
        var min = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.min;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.max;
        })));
        return {
            min: min,
            max: max
        };
    }
    return {
        min: 0,
        max: 0
    };
};
var updateCursorPosition = function(event, newCursorPosition) {
    window.requestAnimationFrame(function() {
        var inputElement = event.target;
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
    });
};
var adjustCursorPosition = function(event, cursorPosition, originalValue, formattedValue) {
    var commaCountBefore = originalValue.slice(0, cursorPosition).split(",").length - 1;
    var commaCountAfter = formattedValue.slice(0, cursorPosition).split(",").length - 1;
    var adjustment = commaCountAfter - commaCountBefore;
    var newCursorPosition = formattedValue === "0" ? 1 : cursorPosition + adjustment;
    updateCursorPosition(event, newCursorPosition);
};
var generateTimeDiffText = function(time) {
    var futureTime = moment__WEBPACK_IMPORTED_MODULE_0___default().utc(time);
    var now = moment__WEBPACK_IMPORTED_MODULE_0___default().utc();
    var diffMilliseconds = futureTime.diff(now);
    var duration = moment__WEBPACK_IMPORTED_MODULE_0___default().duration(diffMilliseconds);
    return "".concat(duration.hours(), " Hours ").concat(duration.minutes(), " Minutes");
};


/***/ }),

/***/ 51981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ InfoTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4303);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75818);







var InfoTable = function(_param) {
    var dataSource = _param.dataSource, _title = _param.title, title = _title === void 0 ? "" : _title, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "dataSource",
        "title"
    ]);
    if (!(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TableContainer */ .xJ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
        "data-cy": "trade-detail-modal-info-table-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                condition: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                    "data-cy": "trade-detail-modal-info-table-title",
                    style: {
                        lineHeight: 0
                    },
                    children: title
                })
            }),
            dataSource.map(function(d, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: d.label,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .DataField */ .lg, {
                        "data-cy": "trade-detail-modal-info-table-item",
                        children: [
                            d.label,
                            " ",
                            d.value
                        ]
                    })
                }, (d === null || d === void 0 ? void 0 : d.key) || "dt-".concat(i));
            })
        ]
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DetailModal)));


/***/ }),

/***/ 4303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DetailModal; }
});

// UNUSED EXPORTS: DetailModal

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts + 1 modules
var useEmittenInfoStore = __webpack_require__(97454);
// EXTERNAL MODULE: ./src/global/Securities/hooks/useLivePriceUpdater.ts
var useLivePriceUpdater = __webpack_require__(76870);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/styled.ts
var DetailModal_styled = __webpack_require__(75818);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/CompanyLabel.tsx








var CompanyLabel = function(param) {
    var notation = param.notation, corpAction = param.corpAction, indexes = param.indexes, tradeType = param.tradeType, dayTradeInfo = param.dayTradeInfo, tradingLimitInfo = param.tradingLimitInfo;
    var syariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
    var isAccel = tradeType === "ACCEL";
    var isDbx = indexes.indexOf("DBX") > -1;
    var isDayTrade = dayTradeInfo === null || dayTradeInfo === void 0 ? void 0 : dayTradeInfo.is_show_multiplier;
    var isTradingLimit = tradingLimitInfo.is_trading_limit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* CompanyLabelContainer */.gL, {
        align: "center",
        justify: "center",
        "data-cy": "trade-detail-modal-company-label=container",
        children: [
            notation.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/ic_indicator.svg",
                    alt: "warning",
                    width: "12px"
                })
            }),
            corpAction.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/corp_action_event_icon.svg",
                    alt: "corp_action"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* LabelDayTrade */.$y, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/lightning-filled-company.svg",
                            alt: "",
                            height: "14",
                            width: "14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            size: "12px",
                            color: "#8277f8",
                            family: "bold",
                            children: [
                                dayTradeInfo.multiplier,
                                "x"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isTradingLimit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TradingLimitBadge */.o7, {
                    children: tradingLimitInfo.haircut_percentage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isAccel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "Akselerasi"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDbx,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "DBX"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: syariah,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "Syariah"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var DetailModal_CompanyLabel = (CompanyLabel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/BondsCompany.tsx













var BondsCompany = function(param) {
    var showPrice = param.showPrice, symbol = param.symbol, iconUrl = param.iconUrl, bondsName = param.bondsName, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.product
        ];
    }), 1), product = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyCard */.SQ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/symbol/".concat(symbol),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                as: "a",
                justify: "space-between",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        "data-cy": "trade-detail-modal-bond-company-show-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: iconUrl || constants/* FALLBACK_AVATAR_SRC */.sW,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                pl: "15px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            children: symbol
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: color/* default.midgray */.Z.midgray,
                                        // @ts-expect-error
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: bondsName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showBondPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            pr: "8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    align: "right",
                                    width: "80px",
                                    children: (0,number/* formatPercentage */.rl)(product === null || product === void 0 ? void 0 : (ref = product.meta) === null || ref === void 0 ? void 0 : ref.sell_price_rate, false, "0,0.00", true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "#969696",
                                    size: "14px",
                                    align: "right",
                                    width: "80px",
                                    children: "Harga Jual"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightSvg */.dj, {})
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_BondsCompany = (BondsCompany);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/Company.tsx


















var CompanyContainer = function(param) {
    var children = param.children, href = param.href, onClick = param.onClick, disabled = param.disabled;
    return onClick || disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyButton */.R, {
        onClick: onClick,
        disabled: disabled,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: children
    });
};
var Company = function(param) {
    var symbol = param.symbol, showPrice = param.showPrice, isBonds = param.isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, bondsName = param.bondsName, onClick = param.onClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var router = (0,next_router.useRouter)();
    var disableRedirect = router.asPath.includes("/symbol/".concat(symbol));
    var ref = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return {
            data: s.data,
            isLoading: s.isLoading,
            loadEmittenInfo: s.loadEmittenInfo,
            resetEmittenInfo: s.resetEmittenInfo,
            updateEmittenInfo: s.updateEmittenInfo
        };
    }, shallow/* default */.Z), emittenInfo = ref.data, isLoading = ref.isLoading, loadEmittenInfo = ref.loadEmittenInfo, resetEmittenInfo = ref.resetEmittenInfo, updateEmittenInfo = ref.updateEmittenInfo;
    var name = emittenInfo.name, icon_url = emittenInfo.icon_url, formatted_price = emittenInfo.formatted_price, change = emittenInfo.change, percentage = emittenInfo.percentage, notation = emittenInfo.notation, corpAction = emittenInfo.corp_action, indexes = emittenInfo.indexes, tradeType = emittenInfo.trade_type, dayTradeInfo = emittenInfo.day_trade_info, tradingLimitInfo = emittenInfo.trading_limit_info;
    var isEmittenEmpty = (0,react.useMemo)(function() {
        return Object.keys(emittenInfo).length === 0;
    }, [
        JSON.stringify(emittenInfo)
    ]);
    (0,useLivePriceUpdater/* default */.Z)({
        symbol: symbol,
        page: "orderlist_detail"
    }, function(param) {
        var lastprice = param.lastprice, liveChange = param.change, percentage_change = param.percentage_change;
        updateEmittenInfo({
            formatted_price: lastprice.toString(),
            change: liveChange.toString(),
            percentage: percentage_change
        });
    });
    (0,react.useEffect)(function() {
        if (symbol && !isRedemption) loadEmittenInfo(symbol);
        return function() {
            resetEmittenInfo();
        };
    }, [
        symbol,
        isRedemption
    ]);
    if (isBonds || isRedemption) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_BondsCompany, {
            symbol: symbol,
            iconUrl: icon_url,
            showPrice: showPrice,
            bondsName: bondsName,
            showBondPrice: showBondPrice
        });
    }
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanySkeletonBlock */.eT, {});
    if (isEmittenEmpty) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyContainer, {
        href: "/symbol/".concat(symbol),
        onClick: onClick,
        disabled: disableRedirect,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyCard */.SQ, {
            as: "a",
            "data-cy": "trade-detail-modal-company-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                width: "100%",
                "data-cy": "trade-detail-modal-company-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        children: [
                            !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* SymbolAvatar */.Mu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "white",
                                    family: "bold",
                                    size: "16px",
                                    children: symbol[0]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: icon_url,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                // @ts-expect-error
                                pl: "15px",
                                "data-cy": "trade-detail-modal-company-info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                children: symbol
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_CompanyLabel, {
                                                notation: notation,
                                                corpAction: corpAction,
                                                indexes: indexes,
                                                tradeType: tradeType,
                                                dayTradeInfo: dayTradeInfo,
                                                tradingLimitInfo: tradingLimitInfo
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: color/* default.midgray */.Z.midgray,
                                        // @ts-expect-error
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "div",
                                    family: "bold",
                                    align: "right",
                                    children: formatted_price
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    align: "right",
                                    // @ts-expect-error
                                    mt: "3px",
                                    color: (0,general/* getColorBasedOnNumber */.pV)(change),
                                    children: [
                                        Number(change) > 0 ? "+" : "",
                                        (0,number/* formatNumber */.uf)(change, false),
                                        " (",
                                        (0,number/* formatPercentage */.rl)(percentage, false),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !showPrice && !disableRedirect,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-trading_back reverse"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_Company = (Company);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/index.tsx





var DetailModal = function(param) {
    var visible = param.visible, onCancel = param.onCancel, title = param.title, symbol = param.symbol, children = param.children, prefix = param.prefix, suffix = param.suffix, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, _bondsName = param.bondsName, bondsName = _bondsName === void 0 ? "" : _bondsName, onCompanyClick = param.onCompanyClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var onClose = function() {
        onCancel();
    };
    var isCompanyInfoVisible = function() {
        if (title === "WITHDRAW") return false;
        return !!symbol;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* Modal */.u_, {
        visible: visible,
        onCancel: onClose,
        centered: true,
        width: 520,
        "data-cy": "trade-detail-modal-container",
        zIndex: 1000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* ModalContent */.hz, {
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* HeaderWrapper */.Pz, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        family: "bold",
                        size: "18px",
                        "data-cy": "trade-detail-modal-title",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* ContentWrapper */.vs, {
                    children: [
                        prefix,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isCompanyInfoVisible(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_Company, {
                                symbol: symbol,
                                showPrice: showPrice,
                                isBonds: isBonds,
                                isRedemption: isRedemption,
                                bondsName: bondsName,
                                onClick: onCompanyClick,
                                showBondPrice: showBondPrice
                            })
                        }),
                        children
                    ]
                }),
                suffix
            ]
        })
    });
};
/* harmony default export */ var components_DetailModal = (DetailModal);


/***/ }),

/***/ 75818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ LabelDayTrade; },
/* harmony export */   "Mu": function() { return /* binding */ SymbolAvatar; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "R": function() { return /* binding */ CompanyButton; },
/* harmony export */   "SQ": function() { return /* binding */ CompanyCard; },
/* harmony export */   "eT": function() { return /* binding */ CompanySkeletonBlock; },
/* harmony export */   "gL": function() { return /* binding */ CompanyLabelContainer; },
/* harmony export */   "hz": function() { return /* binding */ ModalContent; },
/* harmony export */   "lg": function() { return /* binding */ DataField; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "ub": function() { return /* binding */ LabelWrapper; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; }
/* harmony export */ });
/* unused harmony exports BaseContainer, CompanyTextSkeleton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41080);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 19px;\n\n  &.border-bottom {\n    border-bottom: 1px solid #ededed;\n  }\n\n  .ant-progress-inner:not(.ant-progress-circle-gradient)\n    .ant-progress-circle-path {\n    stroke: ",
        ";\n  }\n\n  .free-transfer {\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 19px;\n    color: #00ab6b;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  row-gap: 14px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n\n  legend {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: normal;\n    padding: 0 10px;\n    width: auto;\n    margin-bottom: 0px;\n    margin-left: -10px;\n    text-transform: capitalize;\n  }\n\n  & > div {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #3a645c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 2px 4.5px 2px 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  display: flex;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 0;\n\n  & > .ant-modal-content {\n    border-radius: 3px;\n    max-height: 100vh;\n    overflow: hidden;\n  }\n\n  & .ant-modal-close-x {\n    font-size: 11px;\n  }\n\n  .ant-modal-body {\n    max-height: 100vh;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px 20px 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  flex: 1;\n  overflow: auto;\n\n  & > * {\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n    margin: 0;\n  }\n\n  .ant-skeleton-title {\n    margin: 0 0 8px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  & > .ant-skeleton-button {\n    border-radius: 4px;\n    height: 74px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  width: 100%;\n  max-height: 100vh;\n  gap: 0px;\n  & > div {\n    width: 100%;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}





var CompanyLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-0"
})(_templateObject());
var DataField = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-f6c618c-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var BaseContainerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var BaseContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-2"
})(_templateObject3(), BaseContainerStyle);
var TableContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].fieldset.withConfig */ .ZP.fieldset.withConfig({
    componentId: "sc-f6c618c-3"
})(_templateObject4(), BaseContainerStyle);
var CompanyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-4"
})(_templateObject5(), BaseContainerStyle);
var SymbolAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-5"
})(_templateObject6());
var LabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-6"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var LabelDayTrade = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(LabelWrapper).withConfig({
    componentId: "sc-f6c618c-7"
})(_templateObject8());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-8"
})(_templateObject9());
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-9"
})(_templateObject10());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-10"
})(_templateObject11());
// Company
var CompanyTextSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-11"
})(_templateObject12());
var CompanyButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-f6c618c-12"
})(_templateObject13());
var CompanySkeletonBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Button */ .Z.Button).attrs({
    active: true
}).withConfig({
    componentId: "sc-f6c618c-13"
})(_templateObject14());
var ModalContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-14"
})(_templateObject15());


/***/ }),

/***/ 32978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PnLCurrency; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62974);




function PnLCurrency(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 0 : _amount, _dataCy = param.dataCy, dataCy = _dataCy === void 0 ? "" : _dataCy, _percentage = param.percentage, percentage = _percentage === void 0 ? null : _percentage, _family = param.family, family = _family === void 0 ? "normal" : _family, _isFillEmptyWithDash = param.isFillEmptyWithDash, isFillEmptyWithDash = _isFillEmptyWithDash === void 0 ? false : _isFillEmptyWithDash, _isColorless = param.isColorless, isColorless = _isColorless === void 0 ? false : _isColorless, _isSignless = param.isSignless, isSignless = _isSignless === void 0 ? false : _isSignless, _isOnlyPercentage = param.isOnlyPercentage, isOnlyPercentage = _isOnlyPercentage === void 0 ? false : _isOnlyPercentage, _isHidePositiveSign = param.isHidePositiveSign, isHidePositiveSign = _isHidePositiveSign === void 0 ? false : _isHidePositiveSign, _isMultiline = param.isMultiline, isMultiline = _isMultiline === void 0 ? false : _isMultiline;
    var isPositive = amount > 0;
    var sign = isPositive ? "+" : "-";
    if (isSignless || isPositive && isHidePositiveSign) {
        sign = "";
    }
    var textColor = isPositive ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    if (isColorless) {
        textColor = "";
    }
    if (amount === 0) {
        sign = "";
        textColor = "";
    }
    if (amount === 0 && isFillEmptyWithDash) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            family: family,
            children: "-"
        });
    }
    if (isOnlyPercentage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: [
                sign,
                (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatPercentage */ .rl)(Math.abs(amount), false, "0,0.00", true)
            ]
        });
    }
    var amountDisplayed = "".concat(sign, "Rp").concat((0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(Math.abs(amount)));
    var percentageDisplayed = "";
    if (percentage !== null) {
        var percentageSign = percentage !== 0 ? sign : "";
        percentageDisplayed = "(".concat(percentageSign).concat((0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatPercentage */ .rl)(Math.abs(percentage), false, "0,0.00", true), ")");
    }
    var displayed = "".concat(amountDisplayed, " ").concat(percentageDisplayed);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isMultiline && displayed.length > 22 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    children: amountDisplayed
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    align: "end",
                    children: percentageDisplayed
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: displayed
        })
    });
};


/***/ }),

/***/ 80557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Collapsible; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Collapsible/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        "; /* This will make the content expand upwards */\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  cursor: pointer;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-right: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  transition: max-height 0.5s ease-out;\n  max-height: ",
        ";\n  width: 100%;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n\n  transition: all 0.25s ease-in-out;\n\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-0"
})(_templateObject(), function(props) {
    return props.direction === "top" ? "column" : "column-reverse";
});
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-1"
})(_templateObject1());
var HeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-2"
})(_templateObject2());
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-3"
})(_templateObject3(), function(props) {
    return props.isOpen ? props.maxHeight : "0";
});
var Chevron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-4"
})(_templateObject4(), function(p) {
    return p.direction === "top" && "rotate(180deg)";
}, function(p) {
    return p.direction === "right" && "-rotate(90deg)";
}, function(p) {
    return p.direction === "bottom" && "rotate(0deg)";
}, function(p) {
    return p.direction === "left" && "rotate(90deg)";
});

;// CONCATENATED MODULE: ./src/global/Collapsible/index.tsx




function Collapsible(param) {
    var children = param.children, _defaultOpenState = param.defaultOpenState, defaultOpenState = _defaultOpenState === void 0 ? false : _defaultOpenState, _header = param.header, header = _header === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : _header, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "300px" : _maxHeight, _expandDirection = param.expandDirection, expandDirection = _expandDirection === void 0 ? "top" : _expandDirection;
    var ref = (0,react.useState)(defaultOpenState), isOpen = ref[0], setIsOpen = ref[1];
    var toggleCollapsible = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        direction: expandDirection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                isOpen: isOpen,
                maxHeight: maxHeight,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                onClick: toggleCollapsible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContent, {
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        direction: isOpen ? "top" : "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownSvg/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var global_Collapsible = (Collapsible);


/***/ }),

/***/ 59359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ exodusApiInstance; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusApiInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    disabledErrorAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};


/***/ }),

/***/ 68861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDownSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M4 6l4 4 4-4"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDownSvg);


/***/ }),

/***/ 42958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var InfoSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2",
            d: "M6.5 11.167a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334zM6.5 8.367V6.5M6.5 4.633h.004"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoSvg);


/***/ }),

/***/ 97454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useEmittenInfoStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/emitten.ts




var getEmittenInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", exodus/* exodusApiInstance.disabledErrorAlert.get */.l.disabledErrorAlert.get(apiEndpoint/* emittenEndpoint.emittenInfo */.CI.emittenInfo(symbol)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEmittenInfo(symbol) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts






var initialState = {
    data: {},
    isLoading: false
};
var useEmittenInfoStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadEmittenInfo: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getEmittenInfo(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetEmittenInfo: function() {
            set(initialState);
        },
        updateEmittenInfo: function(newData) {
            set(function(state) {
                return {
                    data: (0,_object_spread/* default */.Z)({}, state.data, newData)
                };
            });
        }
    });
});
/* harmony default export */ var stores_useEmittenInfoStore = (useEmittenInfoStore);


/***/ }),

/***/ 32471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useBondInfoModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38875);




var initialState = {
    modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
};
var useBondInfoModal = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
        openInfoModal: function openInfoModal(infoType) {
            set({
                modalInfoType: infoType
            });
        },
        closeInfoModal: function closeInfoModal() {
            set({
                modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
            });
        }
    });
});


/***/ }),

/***/ 70098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ FieldSet; },
/* harmony export */   "CQ": function() { return /* binding */ CouponHistoryContainer; },
/* harmony export */   "F0": function() { return /* binding */ ModalContainer; },
/* harmony export */   "OT": function() { return /* binding */ UnitInput; },
/* harmony export */   "Y0": function() { return /* binding */ ModalRoot; },
/* harmony export */   "a$": function() { return /* binding */ BorderedContainer; },
/* harmony export */   "fe": function() { return /* binding */ ModalBody; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "mz": function() { return /* binding */ ModalFooter; },
/* harmony export */   "pT": function() { return /* binding */ TextLoadingShimmer; },
/* harmony export */   "w2": function() { return /* binding */ HistoryGroupContainer; },
/* harmony export */   "xB": function() { return /* binding */ ModalHeader; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; }
/* harmony export */ });
/* unused harmony export InputSectionWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 264px;\n  min-width: 415px;\n\n  padding: 20px;\n\n  max-width: 100%;\n\n  .ant-modal-close {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 503px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  min-height: 126px;\n\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 24px;\n  margin-bottom: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item {\n    margin-bottom: 20px;\n  }\n  .ant-slider-rail {\n    background-color: #dadada;\n    display: block;\n  }\n  .ant-row.ant-form-item {\n    height: 24px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #dadada;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  background-color: #ededed;\n  border-radius: 4px;\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item-control-input {\n    background-color: ",
        ";\n    border: ",
        ";\n    padding-left: ",
        ";\n    color: ",
        ";\n    border-radius: 2px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Firefox */\n  -moz-appearance: textfield !important;\n\n  :focus::placeholder {\n    color: transparent;\n  }\n  ::placeholder {\n    letter-spacing: -1px;\n  }\n\n  /* Chrome, Safari, Edge, Opera */\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n\n    margin: 0;\n  }\n\n  caret-color: #1db87a;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  width: 100%;\n  padding: 8px 0px;\n  border-bottom: 1px solid #f1f1f1;\n\n  :last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 2px;\n\n  min-height: 360px;\n  max-height: 400px;\n\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ModalRoot = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-38eda78f-0"
})(_templateObject());
var ModalContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-1"
})(_templateObject2(), function(p) {
    return p.modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
});
var ModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-2"
})(_templateObject3());
var ModalBody = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-3"
})(_templateObject4());
var ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-4"
})(_templateObject5());
var InputSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-5"
})(_templateObject6());
var Field = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-6"
})(_templateObject7(), function(p) {
    return p.isAccordion ? "16px" : 0;
});
var FieldSet = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-7"
})(_templateObject8());
var BorderedContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-8"
})(_templateObject9());
var TextLoadingShimmer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-9"
})(_templateObject10(), function(p) {
    return p.height || "16px";
}, function(p) {
    return p.width || "100%";
});
var FormItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-38eda78f-10"
})(_templateObject11(), function(props) {
    return props.disabled ? "#f7f7f7" : "transparent";
}, function(props) {
    return props.disabled ? "1px solid #dadada" : "none";
}, function(props) {
    return props.disabled ? "8px" : "unset";
}, function(props) {
    return props.disabled ? "#858585" : "unset";
});
var UnitInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-38eda78f-11"
})(_templateObject12());
var HistoryGroupContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-12"
})(_templateObject13());
var CouponHistoryContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-13"
})(_templateObject14());


/***/ })

}]);